import { render, staticRenderFns } from "./ResetTwoFaSuccess.vue?vue&type=template&id=671e6bec&scoped=true&"
import script from "./ResetTwoFaSuccess.vue?vue&type=script&lang=js&"
export * from "./ResetTwoFaSuccess.vue?vue&type=script&lang=js&"
import style0 from "./ResetTwoFaSuccess.vue?vue&type=style&index=0&id=671e6bec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671e6bec",
  null
  
)

export default component.exports